export default __webpack_public_path__ + "static/media/misc-closetA-1920w.e92f834b.avif";